import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

@Directive({
  selector: '[ngModelGroup] [uniqueCollectionValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: UniqueCollectionValidator, multi: true }],
  standalone: false
})
export class UniqueCollectionValidator extends BaseValidator {

  private data: {
    includeDisabled: boolean
  };

  @Input()
  get uniqueCollectionValidator(): {
    includeDisabled: boolean
  } {

    return this.data;
  }

  set uniqueCollectionValidator(value: {
    includeDisabled: boolean
  }) {
    if (value == null || !value.includeDisabled) {
      value = {
        includeDisabled: false
      };
    }
    this.data = value;
    if (this._onChange) this._onChange();
  }

  constructor() {
    super('uniqueCollectionValidator');
  }

  protected getValidationResult(control: any) {

    const controls = Object.keys(control.controls).map(x => control.controls[x]);
    const values = controls.filter(x => (this.data?.includeDisabled || !x.disabled) && x.value).map(x => x.value);

    const duplicateValues = values.filter((item, pos) => values.indexOf(item) !== pos);

    controls.forEach(x => {
      const isInvalid = duplicateValues.indexOf(x.value) >= 0 && !x.disabled;
      if (isInvalid) {
        const errors = {};
        Object.assign(errors, x.errors);
        Object.assign(errors, { 'uniqueCollectionValidator': 'Duplicate record is already selected' });

        x.setErrors(errors);
        x.markAsTouched();
      } else {
        const errors = {};
        Object.assign(errors, x.errors);
        delete errors['uniqueCollectionValidator'];

        x.setErrors(errors);
        x.updateValueAndValidity({ onlySelf: true });
      }
    });

    return null;
  }
}
